import React, { useState, Fragment, useEffect } from 'react'
import { Card, Form, Row, Col, Button } from 'react-bootstrap'
import {LoadingComponent} from 'recupero-comunes'
import { isValidParam } from '../../common/Formatos'
import {serviceGetDocumento, serviceGetCfgForm} from '../../api/api-ver-informe-profesional.js';

const VerInformeRAT = ({ showModal, setShowModal, solicitud}) => {

    const [loading, setLoading] = useState(false);
    const [cfg_form, setCfg_form] = useState(null);

    const handleClose = () => {
        setShowModal(false);
    }
    useEffect(() => {
        if (showModal) {
            getCfgForm(solicitud.idOrgBien);            
        }
    }, [showModal])
    
    const getCfgForm = async (idOrgBien) => {
        const query = Buffer.from(JSON.stringify({ rutcia: idOrgBien, idform: 94})).toString('base64');
        const response = await serviceGetCfgForm(query);
        setCfg_form(response);
    }

    const handleVerPDF = async (folioDocumento) => {
        console.log("Ver documento: ", folioDocumento);
        try {   

            if (folioDocumento) {
                setLoading(true); 
                let parametros = JSON.stringify({
                    idCaso: solicitud && solicitud['idCaso'],
                    idImplicadoCaso: solicitud && solicitud['idImplicado'],
                    idCompania: solicitud && solicitud['idOrgBien'],
                    idfolioCarga: folioDocumento
                });
                console.log("en handleDocumento...", parametros);
                let query = Buffer.from(parametros).toString('base64')

                const response = await serviceGetDocumento(query);
                setLoading(false);

                var link = document.createElement("a");
                link.download = response.filename;
                link.href = "data:" + response.mimetype + ";base64," + response.file;
                link.click();
            }
        } catch (error) {
            console.log("error:", error);
            setLoading(false);
        }
    }
return (
    <div>
        <Fragment>
            <LoadingComponent show={loading}/>
            <Card >
                <Card.Header className='cardHeader'>
                    {(cfg_form && cfg_form["ver-informerat-titleing"]) ? cfg_form["ver-informerat-titleing"] : 'Ver Informe RAT '} - ID Caso {solicitud && solicitud['idCaso']}
                </Card.Header>
                <Card.Body>

                    <Row className='containerHeader'>
                        <Col md='3'>
                            <Form.Label style={{ fontWeight: 'bold', fontSize: '16px' }}>
                                {(cfg_form && cfg_form["ver-informerat-title-datsin"]) ? cfg_form["ver-informerat-title-datsin"] : 'Datos del Siniestro'}
                            </Form.Label>
                        </Col>
                    </Row>
                    <Row className='containerHeader'>
                        <Col md='2'>
                            <Form.Label style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {(cfg_form && cfg_form["ver-informerat-datsin-sin"]) ? cfg_form["ver-informerat-datsin-sin"] : 'Siniestro'}
                            </Form.Label>
                            <br />
                            <Form.Text className='mb-3'>
                                {solicitud && isValidParam(solicitud['siniestro']) ? solicitud['siniestro'] : ''}
                            </Form.Text>
                        </Col>
                        <Col md='2'>
                            <Form.Label style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {(cfg_form && cfg_form["ver-informerat-datsin-placa"]) ? cfg_form["ver-informerat-datsin-placa"] : 'Placa'}
                            </Form.Label>
                            <br />
                            <Form.Text className='mb-3'>
                                {solicitud && isValidParam(solicitud['placa']) ? solicitud['placa'] : ''}
                            </Form.Text>
                        </Col>
                        <Col md='2'>
                            <Form.Label style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {(cfg_form && cfg_form["ver-informerat-datsin-fechasig"]) ? cfg_form["ver-informerat-datsin-fechasig"] : 'Fecha Asignación'}
                            </Form.Label>
                            <br />
                            <Form.Text className='mb-3'>
                                {solicitud && isValidParam(solicitud['fecSolicitudFormat']) ? solicitud['fecSolicitudFormat'] : ''}
                            </Form.Text>
                        </Col>
                        <Col md='3'>
                            <Form.Label style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {(cfg_form && cfg_form["ver-informerat-datsin-respsol"]) ? cfg_form["ver-informerat-datsin-respsol"] : 'Responsable CIA Solicita'}
                            </Form.Label>
                            <br />
                            <Form.Text className='mb-3'>
                                {solicitud && isValidParam(solicitud['responsableSolicita']) ? solicitud['responsableSolicita'] : ''}
                            </Form.Text>
                        </Col>
                        <Col md='3'>
                            <Form.Label style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {(cfg_form && cfg_form["ver-informerat-datsin-comentario"]) ? cfg_form["ver-informerat-datsin-comentario"] : 'Comentario CIA'}
                            </Form.Label>
                            <br />
                            <Form.Text className='mb-3'>
                                {solicitud && isValidParam(solicitud['comentario']) ? solicitud['comentario'] : null}
                            </Form.Text>
                        </Col>
                    </Row>
                    <Row className='containerHeader'>
                        <Col md='4'>
                            <Form.Label className='mt-3 mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {(cfg_form && cfg_form["ver-informerat-datsin-abogado"]) ? cfg_form["ver-informerat-datsin-abogado"] : 'Abogado del Caso'}
                            </Form.Label>
                            <br />
                            <Form.Text className='mb-3'>
                                {solicitud && isValidParam(solicitud['responsableAsignado']) ? solicitud['responsableAsignado'] : ''}
                            </Form.Text>
                        </Col>
                        <Col md='4'>
                            <Form.Label className='mt-3 mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {(cfg_form && cfg_form["ver-informerat-datsin-fechaaud"]) ? cfg_form["ver-informerat-datsin-fechaaud"] : 'Fecha Audiencia Informe'}
                            </Form.Label>
                            <br />
                            <Form.Text className='mb-3'>
                                {solicitud && isValidParam(solicitud['FechaAudiencia']) ? solicitud['FechaAudiencia'] : ''}
                            </Form.Text>
                        </Col>
                        <Col md='4'></Col>
                    </Row>

                    <hr style={{ borderTop: '2px solid #04005D' }}></hr>
                    <Row className='containerHeader'>
                        <Col md='3'>
                            <Form.Label style={{ fontWeight: 'bold', fontSize: '16px' }}>
                                {(cfg_form && cfg_form["ver-informerat-title-datinf"]) ? cfg_form["ver-informerat-title-datinf"] : 'Datos del Informe'}
                            </Form.Label>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="5">
                            <Form.Label className='mb-2 mt-3' style={{fontWeight: 'bold',fontSize: '14px'}}>
                                {(cfg_form && cfg_form['ver-informerat-datinf-input-comentarios']) ? cfg_form && cfg_form['ver-informerat-datinf-input-comentarios'] : 'Comentarios'}
                            </Form.Label>
                            {' '}
                            <br/>
                            <Form.Text className='mb-3'>
                                {solicitud && solicitud.informe && isValidParam(solicitud.informe['comentarios']) ? solicitud.informe['comentarios'] : ''}
                            </Form.Text>
                        </Col>
                        <Col md='2'>
                            <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {(cfg_form && cfg_form['ver-informerat-datinf-input-fechainf']) ? cfg_form && cfg_form['ver-informerat-datinf-input-fechainf'] : 'Fecha Informe'}
                            </Form.Label>
                            {' '}
                            <br/>
                            <Form.Text className='mb-3'>
                                {solicitud && solicitud.informe && isValidParam(solicitud.informe['fecInformeFormat']) ? solicitud.informe['fecInformeFormat'] : ''}
                            </Form.Text>                                      
                        </Col>
                        <Col md='5'>
                            <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {(cfg_form && cfg_form['ver-informerat-datinf-input-verdocto']) ? cfg_form && cfg_form['ver-informerat-datinf-input-verdocto'] : 'Subir Informe'}
                            </Form.Label>
                            <br/>
                            <a
                                href="javascript:void(0);"
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (!solicitud.informe?.idfolioCargaDocto) {                              
                                        return;
                                    }
                                    handleVerPDF(solicitud.informe?.idfolioCargaDocto);
                                }}
                                style={{ display: 'flex', alignItems: 'center', marginTop: '10px', 
                                    color: !solicitud.informe?.idfolioCargaDocto ? 'gray' : 'red',
                                    pointerEvents: !solicitud.informe?.idfolioCargaDocto ? 'none' : 'auto',
                                    opacity: !solicitud.informe?.idfolioCargaDocto ? 0.5 : 1
                                }}
                            >
                                {/* SVG como ícono */}
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-file-earmark-pdf" viewBox="0 0 20 20">
                                    <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
                                    <path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z"/>
                                </svg>
                            </a>                                               
                        </Col>
                    </Row>

                    <hr style={{ borderTop: '2px solid #04005D' }}></hr>
                    <Row className='containerHeader'>
                        <Col className="d-grid d-md-flex justify-content-md-end">
                            <Button style={{ width: '110px', marginRight: '5px' }} variant='outline-info' onClick={handleClose}>
                                {(cfg_form && cfg_form["ver-informerat-btncerrar"]) ? cfg_form["ver-informerat-btncerrar"] : 'Cerrar'}
                            </Button>                                
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <style type='text/css'>
                {`
                    .cardHeader {
                        background-color: #77789b;
                        color: #FFFFFF;
                    }
                    .containerHeader {
                        display: flex;
                        justify-content: space-between;
                    }
                    .customCard {
                        padding-top: 0;
                        padding-left: 0;
                        padding-right: 0;
                        padding: 1rem;
                    }
                    .customHeaderCard {
                        background-color: #676999;
                        color: #fff;
                        font-size: 17px;
                        font-weight: 600;
                        text-align: center;
                        text-decoration: underline;
                    }
                    .cursor {
                        cursor: pointer;
                    }
                    .btn-carpeta {
                        background-color: #F0AD3E;
                        color: #FFFFFF;
                        width: 140px;                    
                    }
                    .btn-carpeta:hover{
                        background-color:#e1b97f;
                        color: #FFFFFF;
                    }
                    .btn-solicitar {
                        background-color: #C14B49;
                        color: #FFFFFF;
                        width: 140px;
                        padding:6px 0px 6px 0px;
                    }
                    .btn-solicitar:hover{
                        background-color:  #F6897E;
                        color: #FFFFFF;
                    }
                `}
            </style>         
        </Fragment>
    </div>
  )
}
export default VerInformeRAT